import React from 'react';
import { Layers } from 'lucide-react';
import { Project } from '../../../../../types/project';
import { MachineList, FeatureSection, WeldingSection } from '../common';

interface SpoolsSectionProps {
  project: Project;
}

export const SpoolsSection = ({ project }: SpoolsSectionProps) => {
  if (!project.projectTypes.fabrication?.options.spools?.selected) {
    return null;
  }
  const { features } = project.projectTypes.fabrication.options.spools;

  return (
    <div className="border-l-2 border-purple-200 pl-4">
      <h5 className="text-purple-800 font-medium mb-4 flex items-center gap-2">
        <Layers className="h-5 w-5" />
        Spool fabrication
      </h5>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4 relative">
        <div className="absolute inset-y-0 left-[19%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[39%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[59%] w-px bg-gray-200" />
        <div className="absolute inset-y-0 left-[79%] w-px bg-gray-200" />

        {features.materialTraceability.enabled && (
          <FeatureSection
            title="Material Traceability"
            bgColor="bg-orange-100"
            textColor="text-orange-800"
          >
            <MachineList machines={features.materialTraceability.machines} />
          </FeatureSection>
        )}

        {features.pipeFitter.enabled && (
          <FeatureSection
            title="PipeFitter"
            bgColor="bg-green-100"
            textColor="text-green-800"
          >
            <MachineList machines={features.pipeFitter.machines} />
          </FeatureSection>
        )}

        {features.welding.enabled && (
          <WeldingSection
            machines={features.welding.machines}
            bgColor="bg-purple-100"
            textColor="text-purple-800"
          />
        )}

        {features.ndt.enabled && (
          <FeatureSection
            title="NDT"
            bgColor="bg-yellow-100"
            textColor="text-yellow-800"
          >
            <MachineList machines={features.ndt.machines} />
          </FeatureSection>
        )}

        {features.coating.enabled && (
          <FeatureSection
            title="Coating"
            bgColor="bg-indigo-100"
            textColor="text-indigo-800"
          >
            <MachineList machines={features.coating.machines} />
          </FeatureSection>
        )}
      </div>
    </div>
  );
};
